import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { Buffer } from 'buffer'
import { WalletProvider } from './contexts/WalletContext'
import { TransactionProvider } from './components/wallet/TransactionProvider'
import App from './App'
import './index.css'

if (!('Buffer' in globalThis)) {
	(globalThis as { Buffer?: typeof Buffer }).Buffer = Buffer
}

// Create a client for React Query
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			retry: 3,
			refetchOnWindowFocus: false
		}
	}
})

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<BrowserRouter>
				<WalletProvider>
					<TransactionProvider>
						<App />
						<Toaster
							position="bottom-right"
							toastOptions={{
								duration: 4000,
								style: {
									background: '#1f2937',
									color: '#f9fafb',
									border: '1px solid #374151'
								}
							}}
						/>
					</TransactionProvider>
				</WalletProvider>
			</BrowserRouter>
		</QueryClientProvider>
	</React.StrictMode>
) 